import Router from 'vue-router'
Vue.use(Router)

export default new Router({
	mode: 'history',
	base: '/h5',
	routes: [
    {
      path: '/',
      redirect:'/index'
    },
    {
      path: '/index',
      component: () => import('@/pages/weixiaodian/index'),
      meta:{
        title:"首页",
        keepAlive:true
      },
    },
    {
      path: '/waibugongju',
      component: () => import('@/waibugongju/index'),
      meta:{
        title:"外部工具",
        keepAlive:false
      },
    },
    {
      path: '/shangpinliebiao',
      component: () => import('@/waibugongju/shangpinliebiao'),
      meta:{
        title:"商品列表",
        keepAlive:false
      },
    },
    {
      path: '/shangpinxiangqing',
      component: () => import('@/waibugongju/shangpinxiangqing'),
      meta:{
        title:"商品详情",
        keepAlive:false
      },
    },
    {
      path: '/order',
      component: () => import('@/pages/weixiaodian/order'),
      meta:{
        title:"下单",
        keepAlive:false
      }
    },
    {
      path: '/query',
      component: () => import('@/pages/weixiaodian/query'),
      meta:{
        title:"查询",
        keepAlive:false
      }
    },
    {
      path: '/query_order',
      component: () => import('@/pages/weixiaodian/query_order'),
      meta:{
        title:"查询订单",
        keepAlive:false
      }
    },
    {
      path: '/query_order2',
      component: () => import('@/pages/weixiaodian/query_order2'),
      meta:{
        title:"查询订单",
        keepAlive:false
      }
    },
    {
      path: '/haibao',
      component: () => import('@/pages/weixiaodian/haibao'),
      meta:{
        title:"海报",
        keepAlive:false
      }
    },
    {
      path: '/success',
      component: () => import('@/pages/weixiaodian/success'),
      meta:{
        title:"下单成功",
        keepAlive:false
      }
    },
    {
      path: '/jiameng',
      component: () => import('@/pages/weixiaodian/jiameng'),
      meta:{
        title:"加盟站点",
        keepAlive:false
      }
    },
    {
      path: '/jiameng2',
      component: () => import('@/pages/weixiaodian/jiameng2'),
      meta:{
        title:"加盟站点",
        keepAlive:false
      }
    },
    {
      path: '/peizhi',
      component: () => import('@/pages/weixiaodian/peizhi'),
      meta:{
        title:"设置",
        keepAlive:false
      }
    },
    {
      path: '/jiamengsuccess',
      component: () => import('@/pages/weixiaodian/jiamengsuccess'),
      meta:{
        title:"创建站点成功",
        keepAlive:false
      }
    },
    {
      path: '/geren',
      component: () => import('@/pages/weixiaodian/geren'),
      meta:{
        title:"分销商个人中心",
        keepAlive:false
      }
    },
    {
      path: '/shangchuantouxiang',
      component: () => import('@/pages/weixiaodian/shangchuantouxiang'),
      meta:{
        title:"上传头像",
        keepAlive:false
      }
    },
    {
      path: '/dengjiguize',
      component: () => import('@/pages/weixiaodian/dengjiguize'),
      meta:{
        title:"等级规则",
        keepAlive:false
      }
    },
    {
      path: '/benyuejingyan',
      component: () => import('@/pages/weixiaodian/benyuejingyan'),
      meta:{
        title:"本月经验",
        keepAlive:false
      }
    },
    {
      path: '/dingdanzhuangtai',
      component: () => import('@/pages/weixiaodian/dingdanzhuangtai'),
      meta:{
        title:"订单状态",
        keepAlive:false
      }
    },
    {
      path: '/weixingongzhonghaoyanzheng',
      component: () => import('@/pages/weixiaodian/weixingongzhonghaoyanzheng'),
      meta:{
        title:"微信验证",
        keepAlive:false
      }
    },
    {
      path: '/china10000',
      component: () => import('@/pages/weixiaodian/china10000'),
      meta:{
        title:"电信临时页面",
        keepAlive:false
      }
    },


	]
})



// WEBPACK FOOTER //
// ./src/router/index.js